import appConfig from '@/config/appConfig.typed';
import queryParameters from '@/consts/route/queryParameters';
import appContent from '@/services/content/appContent.typed';

import storageService from '../storage/storageService';

const initAgeGate = (): void => {
    const isAgeGateConfirmed = getIsAgeConfirmed();

    setIsAgeConfirmed(isAgeGateConfirmed);
};

const getIsAgeConfirmed = (): boolean => {
    const params = new URLSearchParams(window.location.search);
    const isAgeGateConfirmed =
        params.get(queryParameters.IS_AGE_CONFIRMED) === 'true' || storageService.getIsAgeGateConfirmedFromStorage();

    return isAgeGateConfirmed;
};

const setIsAgeConfirmed = (isConfirmed: boolean): void => {
    const isStorageConfirmed = storageService.getIsAgeGateConfirmedFromStorage();

    if (isStorageConfirmed !== isConfirmed) storageService.setIsAgeGateConfirmedToStorage(isConfirmed);
};

const isAgeGateRequired = (): boolean => {
    const {isAgeGateEnabled} = appConfig.getAgeGateSettings();
    const ageGatePopupContent = appContent.getAgeGatePopupContent();

    if (!isAgeGateEnabled || !ageGatePopupContent) return false;
    return !getIsAgeConfirmed();
};

const getAgeYears = (dob: Date): number | undefined => {
    if (!dob) return undefined;

    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();

    if (today.getMonth() < dob.getMonth()) age--;

    return age;
};

const validateAge = (year: number, month: number): boolean => {
    if (!year || !month) return false;
    if (month < 1 || month > 12) return false;
    if (year > new Date().getFullYear()) return false;

    const {minPassingAge} = appConfig.getAgeGateSettings();

    if (!minPassingAge) return false;
    const dob = new Date(year, month - 1);
    const ageYears = getAgeYears(dob);

    return ageYears !== undefined && ageYears >= minPassingAge;
};

const isAgeGateLocked = (): boolean => {
    const lockedUntil = storageService.getAgeGateLockedUntilFromStorage();

    if (!lockedUntil) return false;

    if (Date.now() >= lockedUntil) {
        storageService.removeAgeGateLockedUntilFromStorage();
        return false;
    }

    return true;
};

const getRemainingLockTime = (): number => {
    const lockedUntil = storageService.getAgeGateLockedUntilFromStorage();

    if (!lockedUntil) return 0;

    return Math.max(0, lockedUntil - Date.now());
};

const lockAgeGate = (): void => {
    const {lockTime} = appConfig.getAgeGateSettings();

    if (!lockTime) return;

    const lockedUntil = Date.now() + lockTime * 60000;

    storageService.setAgeGateLockedUntilToStorage(lockedUntil);
};

export default {
    initAgeGate,
    isAgeGateRequired,
    getAgeYears,
    validateAge,
    getIsAgeConfirmed,
    setIsAgeConfirmed,
    isAgeGateLocked,
    getRemainingLockTime,
    lockAgeGate,
};
